// OPHORUS
// Cartes produit (._categories) : force les badges de categorie sur une
// seule ligne, cf. utils/fitEllipsis.js pour le calcul. Un ResizeObserver
// (plutot qu'un simple listener sur "resize") permet de recalculer aussi
// quand la largeur du conteneur bouge pour d'autres raisons que le
// redimensionnement de la fenetre (police web qui finit de charger, grille
// qui se met en place apres chargement des images...).
import $ from "jquery";
import fitEllipsisLine from "./fitEllipsis";

const categories = {
	observer: null,

	init() {
		this.observer = new ResizeObserver((entries) => {
			entries.forEach((entry) => fitEllipsisLine(entry.target));
		});

		this.observe();
	},

	observe(scope = document) {
		$(scope).find("._categories").each((i, el) => {
			fitEllipsisLine(el);
			this.observer.observe(el);
		});
	},

	fit(scope = document) {
		this.observe(scope);
	}
};

export default categories;
